import { SvgIcon, TooltipComponent, theme } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ControlGroupContainer = styled.div`
  display: flex;
`;

const Title = styled.div<{ isSplitTest: boolean }>`
  padding: ${({ theme, isSplitTest }) =>
    isSplitTest
      ? `0 ${theme.designToken.spacing1} 0 ${theme.designToken.spacing2}`
      : `0 ${theme.designToken.spacing1} 0 ${theme.designToken.spacing1}`};
`;

export const ControlGroupInfo = ({ ControlGroupWeight, isSplitTest }) => {
  const { t } = useTranslation('campaigns');

  return (
    <>
      <ControlGroupContainer aria-label={t('onsite.editor.workflow.splitTest.contolGroupCard.ariaLabel')}>
        <SvgIcon name="user-slash" size={isSplitTest ? '24' : '16'} />
        <Title isSplitTest={isSplitTest}>
          {ControlGroupWeight}
          {t('onsite.editor.workflow.splitTest.workFlowInfoForControlGroup')}
          {isSplitTest && t('onsite.editor.workflow.splitTest.workFlowInfoForControlGroupApplied')}
        </Title>
        <TooltipComponent
          id="controlGroupTooltip"
          label={t('onsite.editor.workflow.splitTest.workFlowInfoForControlGroupTooltip')}
          position="Right"
        >
          <SvgIcon name="circle-question" size="16" color={theme.designToken.primary700} />
        </TooltipComponent>
      </ControlGroupContainer>
    </>
  );
};
